import { combineEpics } from 'redux-observable';
import { epics as addWorksheetEpics } from '../ReduxViewModels/AddWorksheet';
import { epics as adminEpics } from '../ReduxViewModels/Admin';
import { epics as agsExportEpics } from '../ReduxViewModels/Ags/Export';
import { epics as projectEpics } from '../ReduxViewModels/Ags/Project';
import { epics as agsValidationErrorMessagesEpics } from '../ReduxViewModels/Ags/ValidationError';
import { epics as workOrderEpics } from '../ReduxViewModels/Ags/WorkOrder';
import { epics as workOrderGridEpics } from '../ReduxViewModels/Ags/WorkOrderGrid';
import { epics as amddEpics } from '../ReduxViewModels/AssignedValuesTests';
import { epics as authEpics } from '../ReduxViewModels/Authentication';
import { epics as barcodeEpics } from '../ReduxViewModels/Barcode';
import { epics as dataSyncEpics } from '../ReduxViewModels/DataSync';
import { epics as environmentEpics } from '../ReduxViewModels/Environment';
import { epics as equipmentEpics } from '../ReduxViewModels/Equipment';
import { epics as equipmentInterfacingEpics } from '../ReduxViewModels/EquipmentInterfacing';
import { epics as imageEpics } from '../ReduxViewModels/Images';
import * as importedWorksheetEpics from '../ReduxViewModels/ImportedWorksheet/epics';
import { epics as interLabEpics } from '../ReduxViewModels/InterLab';
import { epics as listEpics } from '../ReduxViewModels/Lists';
import { epics as gaugeStandardisationEpics } from '../ReduxViewModels/NuclearGaugeStandardisation';
import { epics as pltEpics } from '../ReduxViewModels/PlateLoading';
import { epics as hydrometerEpics } from '../ReduxViewModels/PsdHydrometer';
import { epics as psdEpics } from '../ReduxViewModels/PsdSieveAnalysis';
import * as searchWorksheetsEpics from '../ReduxViewModels/SearchWorksheets/epics';
import { epics as serviceSetupEpics } from '../ReduxViewModels/ServiceSetup';
import * as userEpics from '../ReduxViewModels/User/epics';
import { epics as worksheetBatchUpdateEpics } from '../ReduxViewModels/WorksheetBatchUpdate';
import { epics as worksheetEditorEpics } from '../ReduxViewModels/WorksheetEditor';
import { epics as worksheetGridEpics } from '../ReduxViewModels/WorksheetGrid';

/**
 * Epics are flattened into a big list of functions that must have unique names, or they will overwrite each other.
 * Namespace each imported file to ensure names are unique.
 */
const namespace = (prefix, obj) => {
  const newObj = {};
  Object.entries(obj).forEach((key) => {
    Object.assign(newObj, { [`${prefix}_${key[0]}`]: obj[key[0]] });
  });
  return newObj;
};

const allEpics = Object.values({
  ...namespace('ws', worksheetEditorEpics),
  ...namespace('ds', dataSyncEpics),
  ...namespace('list', listEpics),
  ...namespace('auth', authEpics),
  ...namespace('user', userEpics),
  ...namespace('iw', importedWorksheetEpics),
  ...namespace('sw', searchWorksheetsEpics),
  ...namespace('admin', adminEpics),
  ...namespace('equip', equipmentEpics),
  ...namespace('psd', psdEpics),
  ...namespace('hyd', hydrometerEpics),
  ...namespace('plt', pltEpics),
  ...namespace('ss', serviceSetupEpics),
  ...namespace('wsg', worksheetGridEpics),
  ...namespace('add', addWorksheetEpics),
  ...namespace('env', environmentEpics),
  ...namespace('equipInterface', equipmentInterfacingEpics),
  ...namespace('wo', workOrderEpics),
  ...namespace('wog', workOrderGridEpics),
  ...namespace('p', projectEpics),
  ...namespace('ags', agsExportEpics),
  ...namespace('agsVem', agsValidationErrorMessagesEpics),
  ...namespace('wbu', worksheetBatchUpdateEpics),
  ...namespace('il', interLabEpics),
  ...namespace('bar', barcodeEpics),
  ...namespace('amdd', amddEpics),
  ...namespace('img', imageEpics),
  ...namespace('ngs', gaugeStandardisationEpics),
});

const rootEpic = combineEpics(...allEpics);

export default rootEpic;
